var exports = {
  "N1": "ChannelHeader.module__headerContainer___MjQ2YT",
  "dL": "ChannelHeader.module__headerWrapper___MjQ2YT",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___MjQ2YT",
  "hE": "ChannelHeader.module__headerContainerCallActive___MjQ2YT",
  "Ud": "ChannelHeader.module__headerLeftSection___MjQ2YT",
  "Gv": "ChannelHeader.module__backButton___MjQ2YT",
  "wK": "ChannelHeader.module__backButtonDesktop___MjQ2YT" + " " + "ChannelHeader.module__backButton___MjQ2YT",
  "j2": "ChannelHeader.module__backIcon___MjQ2YT",
  "Ir": "ChannelHeader.module__backIconBold___MjQ2YT" + " " + "ChannelHeader.module__backIcon___MjQ2YT",
  "CY": "ChannelHeader.module__leftContentContainer___MjQ2YT",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___MjQ2YT",
  "BN": "ChannelHeader.module__mobileButton___MjQ2YT",
  "Vt": "ChannelHeader.module__desktopButton___MjQ2YT" + " " + "ChannelHeader.module__mobileButton___MjQ2YT",
  "R3": "ChannelHeader.module__avatarWrapper___MjQ2YT",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___MjQ2YT",
  "_D": "ChannelHeader.module__groupDmHeaderInner___MjQ2YT",
  "ab": "ChannelHeader.module__groupDmEditIcon___MjQ2YT",
  "HA": "ChannelHeader.module__channelName___MjQ2YT",
  "$7": "ChannelHeader.module__groupDmChannelName___MjQ2YT",
  "kf": "ChannelHeader.module__dmNameWrapper___MjQ2YT",
  "a1": "ChannelHeader.module__userTag___MjQ2YT",
  "p": "ChannelHeader.module__channelIcon___MjQ2YT",
  "ml": "ChannelHeader.module__caretRight___MjQ2YT",
  "Nj": "ChannelHeader.module__channelInfoContainer___MjQ2YT",
  "u8": "ChannelHeader.module__followButton___MjQ2YT",
  "B6": "ChannelHeader.module__topicDivider___MjQ2YT",
  "zm": "ChannelHeader.module__topicContainer___MjQ2YT",
  "yu": "ChannelHeader.module__topicButton___MjQ2YT",
  "Am": "ChannelHeader.module__topicButtonOverflow___MjQ2YT",
  "lY": "ChannelHeader.module__headerRightSection___MjQ2YT",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___MjQ2YT",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___MjQ2YT",
  "f5": "ChannelHeader.module__iconButtonDefault___MjQ2YT" + " " + "ChannelHeader.module__iconButton___MjQ2YT",
  "vR": "ChannelHeader.module__iconButtonSelected___MjQ2YT" + " " + "ChannelHeader.module__iconButton___MjQ2YT",
  "rB": "ChannelHeader.module__updateIconButton___MjQ2YT" + " " + "ChannelHeader.module__iconButton___MjQ2YT",
  "l_": "ChannelHeader.module__updateIcon___MjQ2YT",
  "Do": "ChannelHeader.module__updateIconSpinning___MjQ2YT" + " " + "ChannelHeader.module__updateIcon___MjQ2YT",
  "IC": "ChannelHeader.module__iconButtonMobile___MjQ2YT",
  "iA": "ChannelHeader.module__buttonIcon___MjQ2YT",
  "qt": "ChannelHeader.module__buttonIconMobile___MjQ2YT",
  "Dm": "ChannelHeader.module__iconButtonWrapper___MjQ2YT",
  "W9": "ChannelHeader.module__unreadPinIndicator___MjQ2YT",
};

module.exports = exports;
